import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: "pending", text: "未定", short: "未定" },
  { value: "early", text: "上旬", short: "上" },
  { value: "mid", text: "中旬", short: "中" },
  { value: "late", text: "下旬", short: "下" },
  { value: "agenda", text: "予定", short: "予定" },
]);
